import { useEffect } from "react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import CourseTaskManager from "../components/dashboard/CourseTaskManager";
import { useSession } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function CoachCourseDetail() {
  const { data: session, status } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "unauthenticated") {
      navigate("/login");
    }
  }, [status, navigate]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4 animate-pulse">
           <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
           <p className="text-[10px] font-black uppercase tracking-widest text-on-surface-variant">Loading Course Details...</p>
        </div>
      </div>
    );
  }

  const role = (session?.user as any)?.role;
  if (role !== "COACH" && role !== "COACHING_ASSOCIATE" && role !== "ADMIN") return null;

  return (
    <div className="min-h-screen bg-background text-on-background">
      <Header />
      <Sidebar />
      
      <main className="ml-0 md:ml-20 pt-20 pb-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <CourseTaskManager />
        </div>
      </main>
    </div>
  );
}
